<template>
  <div id="index">
    <div id="panel-user">
      <div class="indexuser">
        <h2 style="font-size:3em">{{this.$store.getters.UserInfo.userName }}</h2>
        <div style="color:grey;font-size:0.8rem;display:block;line-height: 24px">{{upId}}</div>
        <div style="color:grey;font-size:0.8rem;display:block">{{returnRate}}</div>
      </div>
      <div style="    position: absolute;width: 97%;z-index: 100000;">
        <router-link to slot="left">
          <mt-button icon="back" @click.native="$router.back(-1)" style=" background: none;"></mt-button>
        </router-link>
          <mt-button icon="more" slot="right" @click="changeLang" style=" float: right; background: none;"></mt-button>
      </div>
    </div>
    <div id="routeView">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import {
    G_UserInfo, G_Promotion, G_PromotionChannel
  } from "../api/api.js";
  export default {
    data() {
      return {
        UserInfo: {
          UserName: "",
          PhoneNumber: "",
          Zalo: "",
          FACEBOOK: "",
          INS: "",
          SupPcode: "",
          Pcode: "",
          DisplayType: ""
        },
        //IndexTable: {
        //  cashable: 0,
        //  monthAddPromoter: 0,
        //  monthAddUser: 0,
        //  monthUserProfit: 0,
        //  rebates: 0,
        //  subPromoter: 0,
        //  subUser: 0,
        //  todayAddPromoter: 0,
        //  todayAddUser: 0,
        //  todayUserProfit: 0,
        //  totalIncome: 0
        //},
        mission: null
      };
    },
    methods: {
      changeLang() {
        this.$store.commit("ChangeLang");
      },
      topg() {
        this.$router.push({ path: '/pg' })
        //this.$store.commit("/pg");
      },
      //getData() {
      //  console.log("获取账号信息");
      //  G_Promotion()
      //    .then(result => {
      //      this.$store.commit("SetIndexTable", result.data[0]);
      //    })
      //    .catch(err => {
      //      console.log(err);
      //    });
      //},
       query() {
         G_PromotionChannel().then(
           result => {
             this.$store.commit("SetUserChannelInfo", result.data);
           })
           .catch(err => {
             console.log(err);
           });
      }



    },
    destroyed() {
      clearInterval(this.mission);
    },
    created() {
      //TODO 获取token
      if (!this.$store.getters.token) {
        this.$router.replace("/login");
      } else {
        G_UserInfo()
          .then(result => {
            this.$store.commit("SetUserInfo", result.data);
          })
          .catch(err => {
            this.$router.replace("/login?status=lose");
          });
        this.query();
      }
      if (!this.$store.getters.UserInfo) {
      
        this.$store.commit("SetUserInfo", this.UserInfo);
       
      }
      console.log(this.$store.getters.UserInfo)
      //if (!this.$store.getters.IndexTable) {
      //  this.$store.commit("SetIndexTable", this.IndexTable);
      //}
     
    },
    computed: {
      upId() {
        let nick = `${this.$store.getters.WordsConfig.Index.firstAgent}${this.$store.getters.UserInfo.pcode}`;
        if (this.$store.getters.UserInfo.SupPcode) {
          nick = `${this.$store.getters.WordsConfig.Index.secondAgent}${this.$store.getters.UserInfo.pcode}`;
        }
        return nick;
      },

      returnRate() {
        let returnRate = `${this.$store.getters.WordsConfig.Index.returnRate}：${(this.$store.getters.UserInfo.proportion * 100) + '%'}`;
        return returnRate;
      },
      title() {
        switch (this.$route.path) {
          case "/index/cls":
            return this.$store.getters.WordsConfig.Index.head_title.v8;
          case "/index/icd":
            return this.$store.getters.WordsConfig.Index.head_title.icd;
          case "/index/dps":
            return this.$store.getters.WordsConfig.Index.head_title.dps;
          case "/index/am":
            return this.$store.getters.WordsConfig.Index.head_title.am;
          default:
            break;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  #index {
    height: 100%;
    min-height: 300px;
  }
  .indexuser {
    padding: 32.5px 0 0 50px;
    width:50%;
    float:left;
  }
  .weui-cell__ft {
    width: 15%;
    max-width:70px;
    padding-right: 13px;
    float: right;
    height: 15rem;
    position: relative;
    margin-right: 5%;
    align-items: center;
    display: flex;
    align-items:center
  }
  .imgstyle {
    width:100%;
    padding-left:15px;
  }
  #panel-user {
    width: 100%;
    height: 15rem;
    overflow: auto;
    background-color: white;
    box-shadow: 0px 2px 4px 3px #dadada;
    background-image: url(../assets/img/titlebgi.jpg);
background-position-y:-40px
  }
 
  .weui-cell__ft:after {
    content: " ";
    display: inline-block;
    height: 6px;
    width: 6px;
    border-width: 2px 2px 0 0;
    border-color: #c8c8cd;
    border-style: solid;
    -webkit-transform: matrix(.71,.71,-.71,.71,0,0);
    transform: matrix(.71,.71,-.71,.71,0,0);
    position: relative;
    top: -2px;
    position: absolute;
    top: 50%;
    margin-top: -4px;
    right: 2px;
  }




  #panel-data {
    height: 100%;
    overflow: auto;
    border-top: solid 1px #26a2ff96;
    display: grid;
    grid-template-columns: 20% 20% 20% 20% 20%;
    grid-template-rows: 50px 50px 50px 50px 50px;
  }

  table {
    width: 100%;
    tr

  {
    .word

  {
    color: grey;
  }

  td {
    font-size: 1.3rem;
  }

  }
  }

  .item {
    font-size: 1rem;
    text-align: center;
    border: 1px solid #e5e4e9;
    padding: 8px;
  }

  .fl {
    float: right;
  }

  #routeView {
    overflow: auto;
    position: absolute;
    min-height: 400px;
    top: 19rem;
    bottom: 0;
    left: 0;
    right: 0;
  }

  #cellList {
    .mint-cell

  {
    border-bottom: solid 1px rgba(128, 128, 128, 0.39);
    div

  {
    font-weight: bold;
  }

  span {
    margin-left: 20px;
    border-radius: 6px;
    padding: 2px 16px;
    background-color: orange;
    width: 50px;
    height: 100%;
    color: white;
    font-weight: normal;
  }

  }
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue